module.exports = __webpack_public_path__ + "static/img/Shipmet Disc Voucher 200 Ribu.5543c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/image/Shipmet Disc Voucher 200 Ribu.png
// module id = Cdo7
// module chunks = 0